<tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
